export const getApiNameForSeatType = (seatType, ownedHubsAndSuiteApiNames) => {
  if (!seatType) return ownedHubsAndSuiteApiNames[0];
  const seatString = String(seatType);
  const [seatName, maybeTier] = seatString.split('-');
  const tier = maybeTier === 'pro' ? 'professional' : maybeTier;
  if (seatName === 'core') {
    return ownedHubsAndSuiteApiNames.find(apiName => apiName.includes('suite') || apiName.includes('marketing') || apiName.includes('content') || apiName.includes('operations') || apiName.includes('core'));
  } else {
    return ownedHubsAndSuiteApiNames.find(apiName => apiName.includes(seatName) && apiName.includes(tier));
  }
};